import type { ReactNode } from "react";

export function SpinnerGraphic(): ReactNode {
  const opacityValues = [
    "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
    "0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0",
    ".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1",
    ".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15",
    ".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25",
    ".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35",
    ".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45",
    ".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55",
    ".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65",
    ".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7",
    ".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85",
    "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
  ] as const;

  return (
    <g strokeWidth={4} strokeLinecap="round" stroke="currentColor">
      {opacityValues.map((values, index) => (
        <line key={index} y1="17" y2="29" transform={`translate(32,32) rotate(${180 + index * 30})`}>
          <animate attributeName="stroke-opacity" dur="750ms" values={values} repeatCount="indefinite" />
        </line>
      ))}
    </g>
  );
}
